import { Collection } from "../../../types/sd";

/**
 * For CQA managers:
 *  - ASSIGNED_TO_ME: workitems belong to the cqa manager
 *  - IN_CQA (Remaining Cases): managers sees all the workitems for all the coders in progress for the project
 *  - CQA_COMPLETE (All Completed): managers sees all the workitems for all the coders completed for the project
 *  - CQA_APPROVED (Approved): managers sees all the workitems for all the coders approved for the project
 *
 * For CQA coders:
 *  -  IN_CQA (Assigned to Me): workitems belong to the cqa coder that are in progress
 *  -  CQA_COMPLETE (Complete): workitems belong to the cqa coder that are completed
 */

export enum WorkitemStatus {
    ASSIGNED_TO_ME = "Assigned to Me", // virtual status used only in UI
    IN_CQA = "IN_CQA",
    CQA_COMPLETE = "CQA_COMPLETE",
    CQA_APPROVED = "CQA_APPROVED",
}

export const WorkItemStatusToLabel = {
    [WorkitemStatus.IN_CQA]: "Assigned to Me",
    [WorkitemStatus.CQA_COMPLETE]: "Complete",
    [WorkitemStatus.CQA_APPROVED]: "Approved",
};

export interface CollectionWithWorkItemCounts extends Collection {
    availability?: boolean;
    rubricVersionId?: number;
    workItemCounts?: {
        [WorkitemStatus.ASSIGNED_TO_ME]: number;
        [WorkitemStatus.IN_CQA]: number;
        [WorkitemStatus.CQA_COMPLETE]: number;
        [WorkitemStatus.CQA_APPROVED]: number;
    }
}